/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { v4 as uuid } from "uuid";
import Select from 'react-select';
import { XIcon } from "@heroicons/react/solid";
import { AddCircle as AddIcon } from '@mui/icons-material';
import { Alert, Snackbar } from '@mui/material';

export default function VoucherAccounting({ type, value, close }) {
  const ACCOUNT_V_TYPES = [
    { value: 'AC-REC', label: 'Receipt' },
    { value: 'AC-PM', label: 'Payment' },
    { value: 'AC-JO', label: 'Journal' },
    { value: 'AC-CO', label: 'Contract' },
    { value: 'AC-CRN', label: 'Credit Note' },
    { value: 'AC-DN', label: 'Debit Note' },
  ]
  const curDate = new Date();
  const modifiedLedgersData = value?.accounting?.map((a, i) => {
    return { key: i, ledger_uuid: a.ledger_uuid, debit: +a.amt < 0 ? Math.abs(a.amt) : '', credit: +a.amt > 0 ? Math.abs(a.amt) : '', amt: Math.abs(a.amt) }
  })
  const DEFAULT_VALUES = {
    voucher_date: type === 'edit' ? (new Date(+value.voucher_date)).getTime() : (new Date(Date.UTC(curDate?.getFullYear(), curDate?.getMonth(), curDate?.getDate(), 0, 0, 0))).getTime(),
    voucher_narration: type === 'edit' ? value.voucher_narration : "",
    voucher_remarks: type === 'edit' ? value.voucher_remarks : "",
    voucher_type: type === 'edit' ? value.voucher_type : "AC-PM",
    voucher_uuid: type === 'edit' ? value.voucher_uuid : "",
    created_at: type === 'edit' ? value.created_at : "",
    ledger_uuid: type === 'edit' ? value?.ledger_uuid : "",
    accounting: type === 'edit' ? modifiedLedgersData : [
      { key: 0, ledger_uuid: '', debit: '', credit: '', amt: '' },
    ],
  }
  const [data, setData] = useState(DEFAULT_VALUES);
  const [ledgers, setLedgers] = useState([]);
  const [editValues, setEditValues] = useState(false);
  const [errorPopUp, setErrorPopUp] = useState(false);
  const vertical = 'bottom';
  const horizontal = 'center'

  useEffect(() => {
    const getLedgers = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/acLedger/ListLedger`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => setLedgers(data))
        .catch(err => console.warn("post request failed", err));
    }
    getLedgers();
    // console.log(data)
  }, [data]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        addNewRow();
        return false;
      }
    });
  }, []);

  const addNewRow = async () => {
    const arr = data.accounting;
    arr.push({
      key: data.accounting.length, ledger_uuid: '', debit: '', credit: '', amt: ''
    });
    setData({ ...data, accounting: arr });
  }

  const CreateVoucherInDB = async () => {
    const arr1 = [];
    data.accounting.forEach((a) => {
      if ((a.debit && a.ledger_uuid) || (a.credit && a.ledger_uuid)) {
        arr1.push({ ledger_uuid: a.ledger_uuid, amt: a.debit ? -a.debit : +a.credit })
      }
    })
    if (arr1.length) {
      const jsonData = {
        accounting: arr1,
        created_at: Date.now(),
        ledger_uuid: data.ledger_uuid,
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        transaction: [],
        voucher_date: data.voucher_date,
        voucher_narration: data.voucher_narration,
        voucher_remarks: data.voucher_remarks,
        voucher_type: data.voucher_type,
        voucher_uuid: uuid(),
      }
      const url = `https://api.myfooddo.com/voucher/CreateVoucher`;
      // const url = `http://localhost:5000/voucher/CreateVoucher`;
      console.log(url, jsonData);
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(jsonData),
      })
        .then(res => res.json())
        .then(data => {
          console.log("CreateVoucher...", data);
        })
        .catch(err => console.warn("post request failed", err));
    }
  }

  const EditVoucherInDB = async () => {
    const arr1 = [];
    data.accounting.forEach((a) => {
      if ((a.debit && a.ledger_uuid) || (a.credit && a.ledger_uuid)) {
        arr1.push({ ledger_uuid: a.ledger_uuid, amt: a.debit ? -a.debit : a.credit })
      }
    })

    if (arr1.length) {
      const json = {
        accounting: arr1,
        created_at: value?.created_at,
        ledger_uuid: data.ledger_uuid,
        outlet_uuid: value?.outlet_uuid,
        transaction: [],
        voucher_date: data.voucher_date,
        voucher_narration: data.voucher_narration,
        voucher_remarks: data.voucher_remarks,
        voucher_type: value?.voucher_type,
        voucher_uuid: value?.voucher_uuid,
      }
      const url = `https://api.myfooddo.com/voucher/EditVoucher`;
      // const url = `http://localhost:5000/voucher/EditVoucher`;
      console.log(url, json);
      await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          console.log("EditVoucher...", data);
        })
        .catch(err => console.warn("post request failed", err));
    }
  }

  const handleSave = async (e) => {
    e.preventDefault();
    const debitTotal = data.accounting?.reduce((a, b) => a + +b.debit, 0);
    const creditTotal = data.accounting?.reduce((a, b) => a + +b.credit, 0);

    if (+creditTotal === +debitTotal) {
      if (data.accounting[0].ledger_uuid) {
        CreateVoucherInDB();
        // EditItemsInDB();
      }
      setData(DEFAULT_VALUES);
    } else {
      setErrorPopUp(true)
      console.log('setErrorPopUp(true)')
    }
  }

  const handleEdit = async (e) => {
    e.preventDefault();
    if (data.accounting[0].ledger_uuid) {
      EditVoucherInDB();
      // EditItemsInDB();
    }
    close();
  }

  return (
    <div className="accountGroup">
      <div className='inventory_header'>
        <h2>Accounting Voucher</h2>
        {type === 'edit' && <XIcon className='closeicon' onClick={close} />}
      </div>

      <div className="topInputs">
        <div className="inputGroup">
          <label htmlFor="date">Date</label>
          <input
            type="date"
            value={
              new Date(data.voucher_date).getFullYear() +
              "-" +
              (
                "00" + (new Date(data.voucher_date)?.getMonth() + 1).toString()
              ).slice(-2) +
              "-" +
              ("00" + new Date(data.voucher_date)?.getDate().toString()).slice(
                -2
              )
            }
            onChange={e => {
              const nDate = new Date(e.target.value);
              setData({
                ...data,
                voucher_date: (new Date(Date.UTC(nDate?.getFullYear(), nDate?.getMonth(), nDate?.getDate(), 0, 0, 0))).getTime()
              })
            }}
            disabled={(type !== 'edit' || editValues) ? false : true}
          />
        </div>
        <div className="inputGroup">
          <label htmlFor="Warehouse">Voucher Type</label>
          <select
            required
            value={data.voucher_type}
            selected={data.voucher_type}
            disabled={(type !== 'edit' || editValues) ? false : true}
            onChange={e => setData({
              ...data,
              voucher_type: e.target.value,
            })}
          >
            {ACCOUNT_V_TYPES.map((a, i) =>
              <option key={i.toString()} value={a.value} >{a.label}</option>
            )}
          </select>
        </div>
      </div>
      <div className="items_table" style={{ flex: '1', padding: '0 10px' }}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 bb b--black-20 ">Sr No.</th>
              <th className="pa2 bb b--black-20 " style={{ width: '30vw' }}>Ledger</th>
              <th className="pa2 bb b--black-20 ">Debit</th>
              <th className="pa2 bb b--black-20 ">Credit</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {data.accounting?.map((l, i) => {
              return <tr key={i}>
                <td className="ph3 pv1 tc bb b--black-20 bg-white">{i + 1}.</td>
                <td className="ph2 pv1 tl bb b--black-20 bg-white">
                  <div className="inputGroup">
                    {(type !== 'edit' || editValues) ?
                      <Select
                        options={ledgers.map((led, j) => {
                          return { value: led.ledger_uuid, label: led.ledger_title, key: j }
                        })}
                        onChange={(e) => {
                          const x = data.accounting.filter((a) => +a.key !== +i)
                          let y = data.accounting.find((a) => +a.key === +i)
                          y.ledger_uuid = e.value;
                          setData({ ...data, accounting: [...x, y] })
                        }}
                        value={ledgers.filter((a) => a?.ledger_uuid === data.accounting.find(a => +a.key === +i)?.ledger_uuid)
                          .map((b) => ({ value: b.ledger_uuid, label: b.ledger_title })
                          )[0] || null}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder='Select Ledger'
                      />
                      : ledgers.find(a => a.ledger_uuid === data.accounting.find((a) => +a.key === +i).ledger_uuid)?.ledger_title || '-'}
                  </div>
                </td>
                <td className="ph2 pv1 tc bb b--black-20 bg-white">
                  {(type !== 'edit' || editValues) ?
                    <input
                      id='debit'
                      type="number"
                      className='qtyInput'
                      onKeyDown={event => {
                        if (event.keyCode === 38 || event.keyCode === 40) event.preventDefault();
                      }}
                      onWheel={(e) => e.preventDefault()}
                      value={data.accounting.find((a) => +a.key === +i)?.debit}
                      onChange={(e) => {
                        const x = data.accounting.filter((a) => +a.key !== +i);
                        let y = data.accounting.find((a) => +a.key === +i);
                        y.debit = e.target.value;
                        y.credit = '';
                        setData({ ...data, accounting: [...x, y] })
                      }}
                      min={1}
                    />
                    : data.accounting.find((a) => +a.key === +i).debit || '-'}
                </td>
                <td className="ph2 pv1 tc bb b--black-20 bg-white">
                  {(type !== 'edit' || editValues) ?
                    <input
                      id='credit'
                      type="number"
                      className='qtyInput'
                      onKeyDown={event => {
                        if (event.keyCode === 38 || event.keyCode === 40) event.preventDefault();
                      }}
                      onWheel={(e) => e.preventDefault()}
                      value={data.accounting.find((a) => +a.key === +i)?.credit}
                      onChange={(e) => {
                        const x = data.accounting.filter((a) => +a.key !== +i);
                        let y = data.accounting.find((a) => +a.key === +i);
                        y.credit = e.target.value;
                        y.debit = '';
                        setData({ ...data, accounting: [...x, y] })
                      }}
                      min={1}
                    />
                    : data.accounting.find((a) => +a.key === +i).credit || '-'}
                </td>
              </tr>
            })}
            <tr>
              <td onClick={addNewRow}>
                <AddIcon sx={{ fontSize: 40 }} style={{ color: '#4AC959' }} />
              </td>
            </tr>
          </tbody>

          <tfoot className="lh-copy">
            <tr className="bg-lightgreen">
              <th className="pa2 bb b--black-20 ">Total</th>
              <th className="pa2 bb b--black-20 "></th>
              <th className="pa2 bb b--black-20 ">
                {data.accounting?.reduce((a, b) => a + +b.debit, 0) || '0'}
              </th>
              <th className="pa2 bb b--black-20 ">
                {data.accounting?.reduce((a, b) => a + +b.credit, 0) || '0'}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="topInputs">
        <textarea
          placeholder="Narration (Displayed)...."
          disabled={(type !== 'edit' || editValues) ? false : true}
          maxLength="200"
          value={data.voucher_narration}
          onChange={e => setData({
            ...data,
            voucher_narration: e.target.value,
          })}
        ></textarea>
        <textarea
          placeholder="Remarks (Not Displayed)...."
          disabled={(type !== 'edit' || editValues) ? false : true}
          maxLength="200"
          value={data.voucher_remarks}
          onChange={e => setData({
            ...data,
            voucher_remarks: e.target.value,
          })}
        ></textarea>
      </div>

      <div className="bottomContent">
        {
          type === 'edit' && !editValues ?
            <button
              onClick={(e) => {
                e.preventDefault();
                setEditValues(true);
                return false;
              }}
            >
              Edit
            </button>
            : <button onClick={type === 'edit' ? handleEdit : handleSave}>Save</button>
        }
      </div>

      <Snackbar
        open={errorPopUp}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={() => setErrorPopUp(false)}
        style={{ bottom: '60px', left: 'calc(50% + 80px)' }}
      >
        <Alert
          onClose={() => setErrorPopUp(false)}
          severity="error"
          variant="filled"
          style={{ fontWeight: 'bold', letterSpacing: '1px', background: 'red' }}
        >
          Debit and Credit Total Should Be Equal.
        </Alert>
      </Snackbar>
    </div>
  );
}
